const {
  LOWER_CASED_BRAND_NAME,
  isFlagler,
  isHealthfully,
} = require('../whitelabel/helpers/contants');

const getBrandConfig = () => {
  try {
    // eslint-disable-next-line import/no-dynamic-require, global-require
    const config = require(`../whitelabel/configs/${LOWER_CASED_BRAND_NAME}/index.js`);

    return config.default;
  } catch (error) {
    console.log(`Failed to load config for ${LOWER_CASED_BRAND_NAME}`, error);
  }
};

const brandConfig = getBrandConfig();

export { isFlagler, isHealthfully };

export default brandConfig;



// WEBPACK FOOTER //
// ./src/constants/brandConfig.js